import {
  Button,
  Dialog,
  DialogTitle,
  IconButton,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import AvatarEditor from "react-avatar-editor";
import CloseIcon from "@mui/icons-material/Close";
import { getUser } from "../services/authService";
import { toast } from "react-toastify";
import { updateProfileAvatar } from "../services/dataService";

const UploadAvatar = ({ open, onClose }) => {
  const [image, setImage] = useState("");
  const user = getUser();

  const uploadImage = async () => {
    try {
      const payload = new FormData();
      payload.append("Id", user?.userDetails.UserId);
      payload.append("file", image);
      await updateProfileAvatar(payload);
      toast.success("Profile image updated.");
      onClose();
    } catch (error) {
      toast.error("Unable to upload profile photo");
    }
  };

  return (
    <Dialog width={400} open={open} onClose={onClose}>
      <DialogTitle id="alert-dialog-title">
        {"Upload Profile Photo"}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <TextField
        type="file"
        onChange={(e) => {
          setImage(e.target.files[0]);
        }}
      />

      <AvatarEditor
        image={image}
        width={250}
        height={250}
        border={50}
        color={[255, 255, 255, 0.6]}
        scale={1.2}
        rotate={0}
      />
      <Button onClick={uploadImage}>Upload</Button>
    </Dialog>
  );
};

export default UploadAvatar;
